import { useContext } from '@/utlis/hooks'

const context = useContext()

export default context